export default "__VITE_ASSET__Ch4UXI$b__"